export const generateButtonClasses = (
  variant,
  color,
  disabled,
  fullWidth,
  className = ""
) => {
  let classes = ["btn"];

  if (fullWidth) classes.push("btn-full");
  if (disabled) {
    classes.push("btn-disabled");
  } else {
    classes.push("btn-enabled");
  }

  if (variant === "contained") {
    classes.push(`btn-contained-${color}`);
    if (disabled) classes.push("btn-contained-disabled");
  }

  if (variant === "outlined") {
    classes.push(`btn-outlined-${color}`);
    if (disabled) classes.push("btn-outlined-disabled");
  }

  if (variant === "text") {
    classes.push(`btn-text-${color}`);
    if (disabled) classes.push("btn-text-disabled");
  }

  if (variant === "ghost") {
    classes.push(`btn-ghost-${color}`);
    if (disabled) classes.push("btn-ghost-disabled");
  }

  if (className) classes.push(className);

  return classes.join(" ");
};
